import { render, staticRenderFns } from "./NavigationButtonFooter.vue?vue&type=template&id=2ccfffc2&scoped=true&"
import script from "./NavigationButtonFooter.vue?vue&type=script&lang=ts&"
export * from "./NavigationButtonFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationButtonFooter.vue?vue&type=style&index=0&id=2ccfffc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfffc2",
  null
  
)

export default component.exports